import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';

const axios = require('axios').default;
import DataTable from '../../DataTable/components/DataTable';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
var ReactDOM = require('react-dom');
import Popup from "reactjs-popup";
import {CopyToClipboard} from 'react-copy-to-clipboard';

import $ from 'jquery';
require('datatables.net-bs4');

const decodeHtml = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "245px",
  "padding": "0px"
}

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "688px",
  "padding": "0px"
}

const TourManager = ({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  searchedSearchTerm,
  toursExist
}) => {
  const [viewingWidgetForTour, setViewingWidgetForTour] = useState(null);
  const dataTableElRef = useRef(null);

  return (
    <div>
      <ToastContainer icon={false} />
      {currentUser.can_manage_tours ? (
        <div className="datatable-right-header-section"
              style={!toursExist ? {top: "-40px"} : {}}>
          <a href={`/teams/${team.id}/tours/new`}
              className="btn btn-primary">
            <strong>New Tour</strong>
          </a>
        </div>
      ) : null}
      {toursExist ? (
        <DataTable title={dataTableTitle}
                  dataSource={dataTableDataSource}
                  columns={dataTableColumns}
                  colGroup={
                    <colgroup>
                      <col span={1} style={{"width": "25%"}} />
                      <col span={1} style={{"width": "25%"}} />
                      <col span={1} style={{"width": "25%"}} />
                      <col span={1} style={{"width": "20%"}} />
                      <col span={1} style={{"width": "5%"}} />
                    </colgroup>
                  }
                  onTableElementSet={
                    (el) => {
                      dataTableElRef.current = el;
                    }
                  }
                  rowCallback={
                    function(row, data, displayNum, displayIndex, dataIndex){
                      let dataTable = this;
                      let tour = JSON.parse(decodeHtml(data.json));
                      var mountTourMenuReact = row.getElementsByClassName("tour-popup-mount-react")[0];

                      ReactDOM.render((
                        <div>
                          {currentUser.can_manage_tours ? (
                            <Popup arrow={false}
                                   offsetY={5}
                                   position="bottom right"
                                   contentStyle={popupContentStyle}
                                   onOpen={
                                     (e) => {
                                       e.preventDefault();
                                     }
                                   }
                                   trigger={open => (
                                     <a href="#"
                                        className="text-muted">
                                       <i className="fas fa-ellipsis-v"></i>
                                     </a>
                                   )} >
                              {close => (
                                <div className='row text-left'>
                                  <div className="col-12">
                                    <p style={{margin: "15px"}}>
                                      <strong className="text-dark">
                                        Tour menu
                                      </strong>
                                    </p>
                                    <hr className="m-0" />
                                    <ul className="list-group offer-inline-menu highlight-primary">
                                      <li className="list-group-item rounded-0"
                                          style={{padding: "15px 15px 12px 15px"}}>
                                        <a href={`/teams/${team.id}/tours/${tour.id}/edit`}
                                            className="text-dark">
                                          <span className="d-inline-block text-center" style={{width: "28px"}}>
                                            <i className="fas fa-pencil"></i>
                                          </span>
                                          Edit tour
                                        </a>
                                      </li>
                                      <li className="list-group-item rounded-0"
                                          style={{
                                            padding: "12px 15px 12px 15px",
                                          }}>
                                        <a href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setViewingWidgetForTour(tour.embed_widget_code);
                                            }}
                                            className="text-dark">
                                          <span className="d-inline-block text-center" style={{width: "28px"}}>
                                            <i className="fas fa-code"></i>
                                          </span>
                                          Download widget
                                        </a>
                                      </li>
                                      <li className="list-group-item"
                                          style={{
                                            padding: "12px 15px 15px 15px",
                                            borderTopLeftRadius: "0px",
                                            borderTopRightRadius: "0px",
                                            borderBottomLeftRadius: "8px",
                                            borderBottomRightRadius: "8px"
                                          }}>
                                        <a href="#"
                                            onClick={(e) => {
                                              e.preventDefault();

                                              if (window.confirm("Are you sure you want to delete this tour?")) {
                                                const url = `/teams/${team.id}/tours/${tour.id}`;
                                                axios.delete(url, {
                                                  headers: {
                                                    'X-CSRF-Token': csrfToken
                                                  }
                                                }).then(response => {
                                                  $(dataTableElRef.current).DataTable().ajax.reload();

                                                  toast.success("Tour was deleted", {
                                                    position: toast.POSITION.TOP_CENTER,
                                                    draggable: false,
                                                    closeOnClick: false,
                                                    autoClose: 5000,
                                                    hideProgressBar: true
                                                  });
                                                  close();
                                                }).catch(error => {
                                                  toast.error("There was an error deleting this tour", {
                                                    position: toast.POSITION.TOP_CENTER,
                                                    draggable: false,
                                                    closeOnClick: false,
                                                    autoClose: 5000,
                                                    hideProgressBar: true
                                                  });
                                                });
                                              }
                                            }}
                                            className="text-dark">
                                          <span className="d-inline-block text-center" style={{width: "28px"}}>
                                            <i className="fas fa-trash"></i>
                                          </span>
                                          Delete tour
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </Popup>
                          ) : null}
                        </div>
                      ), mountTourMenuReact);
                    }
                  }
                  searchedSearchTerm={searchedSearchTerm}
                  order={dataTableOrder} />
      ) : (
        <div className="card border-0 shadow-4"
              style={{
                borderRadius: "12px",
                maxWidth: "400px",
                margin: "60px auto 20px auto"
              }}>
          <div className="card-body"
                style={{padding: "25px"}}>
            <div className="mb-4">
              <div className="d-flex justify-content-center align-items-center"
                  style={{
                     borderRadius: "50%",
                     width: "48px",
                     height: "48px",
                     backgroundColor: "#E3F2FD",
                     marginBottom: "20px"
                  }}>
                <i className="far fa-bus fa-fw"
                    style={{fontSize: "24px", color: "#1976D2"}}></i>
              </div>
            </div>
            <h3 className="mb-2"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#212529"
                }}>
              No tours yet
            </h3>
            <p className="mb-4"
               style={{
                 fontSize: "14px",
                 color: "#6C757D"
               }}>
               Add your first tour to start tracking tour dates, managing bookings, and keeping everything organized in one place.
            </p>
            <a href={`/teams/${team.id}/tours/new`}
               className="btn btn-primary btn-block"
               style={{
                 fontSize: "16px",
                 fontWeight: "600",
                 padding: "12px 24px"
               }}>
              Create your first tour
            </a>
          </div>
        </div>
      )}
      <Popup
        open={viewingWidgetForTour !== null}
        contentStyle={modalContentStyle}
        closeOnDocumentClick={true}
        className={"popup-modal"}
        onClose={() => {
          setViewingWidgetForTour(null);
        }}
      >
        {close => (
          <div className="popup-modal-container">
            <div className="row m-0"
                  style={{borderBottom: "1px solid #E9EAEB"}}>
              <div className="col-12"
                    style={{padding: "24px 24px 20px 24px"}}>
                <div className="d-flex align-items-start">
                  <div className="mr-3">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "48px",
                        height: "48px",
                        background: "white",
                        border: "1px solid #E9EAEB",
                        borderRadius: "10px",
                        boxShadow: "0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset, 0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset, 0px 1px 2px 0px rgba(10, 13, 18, 0.05)"
                      }}
                    >
                      <i
                        className="fas fa-code"
                        style={{fontSize: "24px", color: "#333"}}
                      ></i>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-1" style={{fontSize: "18px", fontWeight: "600"}}>
                      Download your tour widget
                    </p>
                    <p className="text-muted mb-0" style={{fontSize: "14px", marginTop: "-3px"}}>
                      Add this code to the tour page of your site to display the tour
                    </p>
                  </div>
                  <div>
                    <a
                      href="#"
                      className="text-muted"
                      style={{fontSize: "24px"}}
                      onClick={(e) => {
                        e.preventDefault();
                        close();
                      }}
                    >
                      <i className="fal fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-12"
                    style={{padding: "20px 24px 16px 24px"}}>
                <div className="text-right">
                  <CopyToClipboard
                    options={{ format: 'text/plain' }}
                    text={viewingWidgetForTour}
                    onCopy={() => {
                      toast.success("Copied to clipboard!", {
                        position: toast.POSITION.TOP_CENTER,
                        draggable: false,
                        closeOnClick: true,
                        autoClose: 2000,
                        hideProgressBar: true
                      });
                    }}
                  >
                    <button
                      className="btn btn-light-solid-hover"
                      style={{
                        border: "1px solid #D5D7DA",
                        fontWeight: "600"
                      }}
                      type="button"
                    >
                      <i className="far fa-copy mr-2"></i>Copy Code
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
              <div className="col-12" style={{padding: "0px 24px 0px 24px"}}>
                <div
                  className="text-dark d-flex"
                  style={{
                    "fontSize": "16px",
                    "fontFamily": "Roboto Mono, monospace",
                    "padding": "0px",
                    "border": "1px solid #E9EAEB",
                    "borderRadius": "12px",
                    "background": "white",
                    "resize": "none",
                    "whiteSpace": "pre-wrap",
                    "wordBreak": "break-all",
                    "overflow": "hidden"
                  }}>
                  <div className="d-flex"
                        style={{
                          borderRight: "1px solid #E9EAEB",
                          background: "#FAFAFA",
                          padding: "24px",
                          flexDirection: "column",
                          fontWeight: "bold",
                          color: "#717680"
                        }}>
                    <span>1</span>
                    <span>2</span>
                    <span>3</span>
                    <span>4</span>
                    <span>5</span>
                    <span>6</span>
                  </div>
                  <div className='flex-grow-1' style={{padding: "24px 24px 32px 24px"}}>
                    <span style={{color: "#22863a"}}>// Tour Script</span><br /><br />
                    {viewingWidgetForTour}
                  </div>
                </div>
              </div>
              <div className="col-12" style={{padding: "16px 24px 20px 24px"}}>
                <div className="row align-items-start">
                  <div className="col-md-3">
                    <p className="mb-md-0" style={{fontSize: "14px", fontWeight: "600"}}>
                      Need Help?
                    </p>
                  </div>
                  <div className="col-md-9">
                    <div
                      className="text-muted"
                      style={{
                        border: "1px solid #D5D7DA",
                        borderRadius: "8px",
                        background: "#FFF",
                        fontSize: "16px",
                        padding: "12px 14px"
                      }}
                    >
                      Check out these <a href="/support" target="_blank">support documents</a> on styling and embedding your tour widget.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  )
};

TourManager.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  searchedSearchTerm: PropTypes.string,
  toursExist: PropTypes.bool.isRequired
};

export default TourManager;
